<template>
  <page-main
    ref="main"
    :tableData="tableData"
    :loading="loading"
    :tablePage="page"
    @reload="reload"
    :height="height"
  >
    <page-header ref="header" slot="header" @query="getData" />
    <pagination
      size="small"
      align="right"
      slot="pager"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      perfect
      :layouts="['PrevPage', 'NextPage', 'Sizes', 'Total']"
      @change="handlePaginationChange"
    />
  </page-main>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  components: {
    PageHeader,
    PageMain
  },
  mixins: [BaseTable],
  props: {
    height: { type: Number, default: 500 }
  },
  data() {
    return {
      usePage: true,
      loading: false
    }
  },
  methods: {
    getData(form) {
      this.parentDep = {}
      this.loading = true
      this.$api
        .orderGoodsPackageItemSelectApi({
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
